<?xml version="1.0" encoding="UTF-8"?>
<svg width="92px" height="87px" viewBox="0 0 92 87" version="1.1"
  xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink">
  <title>Boiler thumbnail Copy 2@1,5x</title>
  <defs>
    <linearGradient x1="50%" y1="100%" x2="50%" y2="0%" id="linearGradient-1">
      <stop stop-color="#FFFFFF" offset="0%"></stop>
      <stop stop-color="#FFFFFF" offset="100%"></stop>
    </linearGradient>
    <path id="c" d="M32 50h14v14H32z"/>
    <filter id="b" width="119.3%" height="119.3%" x="-9.6%" y="-9.6%" filterUnits="objectBoundingBox">
      <feMorphology in="SourceAlpha" operator="dilate" radius=".35" result="shadowSpreadOuter1"/>
      <feOffset dx="-2" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"/>
      <feComposite in="shadowOffsetOuter1" in2="SourceAlpha" operator="out" result="shadowOffsetOuter1"/>
      <feColorMatrix in="shadowOffsetOuter1" values="0 0 0 0 0.192136377 0 0 0 0 0.192169905 0 0 0 0 0.192129046 0 0 0 1 0"/>
    </filter>
  </defs>
  <g id="Boiler-thumbnail-Copy-2" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
    <rect id="Baggrund-Copy-24" stroke="#D9DDDF" stroke-width="2.24999994" fill="url(#linearGradient-1)" x="1.12499997" y="1.12499997" width="89.7500001" height="84.7500001"></rect>
    <line x1="57.5" y1="58.5" x2="57.5" y2="30.5" id="Line-22-Copy-42" stroke="#215ABE" stroke-width="2.13640017" stroke-linecap="square" stroke-dasharray="7.477400894260427"></line>
    <line x1="82.5" y1="26.5" x2="10.5" y2="26.5" id="Line-22-Copy-37" stroke="#D5283A" stroke-width="2.13640017" stroke-linecap="square"></line>
    <line x1="82.5" y1="58.5" x2="10.5" y2="58.5" id="Line-22-Copy-38" stroke="#215ABE" stroke-width="2.13640017" stroke-linecap="square" stroke-dasharray="7.477400894260427"></line>
    <g id="Group" transform="translate(45.501512, 63.892571)">
      <g id="Group-20" transform="translate(12.453844, 3.558241) rotate(-270.000000) translate(-12.453844, -3.558241) ">
        <rect id="Rectangle" fill="#313131" x="5.33736162" y="2.9652009" width="19.5703259" height="1.18608036"></rect>
        <circle id="Oval" stroke="#313131" stroke-width="1.60230013" fill="#FFFFFF" cx="3.55824108" cy="3.55824108" r="3.55824108"></circle>
      </g>
    </g>
    <g id="????-copy-26" transform="translate(-10.108917, -30.5) rotate(45 39 57)">
      <use fill="#000" filter="url(#b)" xlink:href="#c"/>
      <use fill="#FFF" stroke="#313131" stroke-width="2.7" xlink:href="#c"/>
    </g>
  </g>
</svg>
